import { useAuth, useUser } from "@clerk/clerk-react";
import { useQuery } from "@tanstack/react-query";
import { getMyStatusApiUsersMeGetOptions } from "../generated/api/@tanstack/react-query.gen";

export interface SourceTabFlag {
  enabled: boolean;
  /** True until the status request settles; lets `/source` wait before redirecting. */
  isPending: boolean;
}

/**
 * Whether the Source tab (manufacturer catalog) is shown.
 *
 * The flag is server config (`config.SOURCE_TAB_ENABLED`) rather than a
 * `VITE_` var because one Docker image is built for both environments and the
 * SPA bundle is baked at build time — a build-time var physically cannot
 * differ between staging and production without a second image.
 *
 * Shares `AuthProvider`'s `/api/users/me` query key, so this adds no request.
 * `enabled` is **off** while the query is pending and on error: the fallback
 * is the shipped UI, so production never flashes the unreleased tab.
 */
export function useSourceTabEnabled(): SourceTabFlag {
  const { isSignedIn } = useAuth();
  const { user } = useUser();

  const { data, isPending } = useQuery({
    ...getMyStatusApiUsersMeGetOptions(),
    enabled: Boolean(isSignedIn && user),
  });

  return { enabled: data?.source_tab_enabled ?? false, isPending };
}
